
export const name = "embedded-viral-link-ui";
export const version = "1.5622";
